<template>
    <section class="uses-tailwind px-5">
        <div class="grid grid-cols-6 mb-4 gap-2 items-end">
            <div>
                <ui5-label>
                    {{
                        trans(
                            'cutting_pleating_validation.filters.labels.order_number'
                        )
                    }}
                </ui5-label>
                <ui5-input
                    class="w-full"
                    v-bind:value="filters.productOrderId"
                    v-on:change="filters.productOrderId = $event.target.value"
                    v-bind:placeholder="
                        trans(
                            'cutting_pleating_validation.filters.placeholders.order_number'
                        )
                    "
                />
            </div>
            <div>
                <ui5-label>
                    {{
                        trans(
                            'cutting_pleating_validation.filters.labels.delivery_method'
                        )
                    }}
                </ui5-label>
                <ui5-select
                    v-bind:disabled="isLoadingDeliveryMethodOptions"
                    class="w-full"
                    v-on:change="
                        filters.deliveryMethodId =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option
                        v-for="option in deliveryMethodOptions"
                        :key="'deliveryMethodOption.' + option.value"
                        :selected="filters.deliveryMethodId == option.value"
                        :value="option.value"
                    >
                        {{ option.label }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div>
                <ui5-label>
                    {{
                        trans(
                            'cutting_pleating_validation.filters.labels.order_date'
                        )
                    }}
                </ui5-label>
                <ui5-date-picker
                    class="w-full"
                    format-pattern="yyyy-MM-dd"
                    v-bind:value="filters.orderDate"
                    v-on:change="filters.orderDate = $event.detail.value"
                />
            </div>
            <div>
                <ui5-label>
                    {{
                        trans(
                            'cutting_pleating_validation.filters.labels.color'
                        )
                    }}
                </ui5-label>
                <ui5-input
                    class="w-full"
                    v-bind:value="filters.colorId"
                    v-on:change="filters.colorId = $event.target.value"
                    v-bind:placeholder="
                        trans(
                            'cutting_pleating_validation.filters.placeholders.color'
                        )
                    "
                />
            </div>
            <div>
                <ui5-label>
                    {{
                        trans(
                            'cutting_pleating_validation.filters.labels.product_type'
                        )
                    }}
                </ui5-label>
                <ui5-select
                    v-bind:disabled="isLoadingProductTypeOptions"
                    class="w-full"
                    v-on:change="
                        filters.productTypeId =
                            $event.detail.selectedOption.value
                    "
                >
                    <ui5-option
                        v-for="option in productTypeOptions"
                        :key="'deliveryMethodOption.' + option.value"
                        :selected="filters.productTypeId == option.value"
                        :value="option.value"
                    >
                        {{ option.label }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div class>
                <ui5-button
                    class="border border-primary mb-[3px] hover:text-primary"
                    v-on:click="clearFilters()"
                >
                    {{
                        trans(
                            'cutting_pleating_validation.filters.actions.clear'
                        )
                    }}
                </ui5-button>
            </div>
        </div>
        <Table
            :columns="tableColumns"
            :data="products"
            :actions="tableActions"
            :loading="isLoadingProducts"
        />
    </section>
</template>
<script>
import cuttingPleatingApi from '../api/cuttingPleating';
import localization from '../mixins/localization';
import { showErrorMessage } from '../dialogs';
import Table from '../components/table/Table';

export default {
    data() {
        return {
            products: [],
            isLoadingProducts: false,
            deliveryMethodOptions: [],
            isLoadingDeliveryMethodOptions: false,
            productTypeOptions: [],
            isLoadingProductTypeOptions: false,
            filters: {
                productOrderId: null,
                deliveryMethodId: null,
                orderDate: null,
                colorId: null,
                productTypeId: null,
            },
        };
    },
    watch: {
        filters: {
            handler() {
                this.fetchProducts();
            },
            deep: true,
        },
    },
    computed: {
        tableColumns() {
            return [
                {
                    key: 'productOrderId',
                    label: this.trans(
                        'cutting_pleating_validation.table.headers.product_order_id'
                    ),
                },
                {
                    key: 'productNumber',
                    label: this.trans(
                        'cutting_pleating_validation.table.headers.product_number'
                    ),
                },
                {
                    key: 'productTypeLabel',
                    label: this.trans(
                        'cutting_pleating_validation.table.headers.product_type_label'
                    ),
                },
                {
                    key: 'reference',
                    label: this.trans(
                        'cutting_pleating_validation.table.headers.reference'
                    ),
                },
                {
                    key: 'customerName',
                    label: this.trans(
                        'cutting_pleating_validation.table.headers.customer_name'
                    ),
                },
                {
                    key: 'deliveryMethodLabel',
                    label: this.trans(
                        'cutting_pleating_validation.table.headers.delivery_method_label'
                    ),
                },
                {
                    key: 'ralNumber',
                    label: this.trans(
                        'cutting_pleating_validation.table.headers.ral_number'
                    ),
                },
                {
                    key: 'ralType',
                    label: this.trans(
                        'cutting_pleating_validation.table.headers.ral_type'
                    ),
                },
                {
                    key: 'powderNumber',
                    label: this.trans(
                        'cutting_pleating_validation.table.headers.powder_number'
                    ),
                },
            ];
        },
        tableActions() {
            return [
                {
                    icon: 'fa fa-eye',
                    action: (row) => {
                        this.$router.push(
                            `/validate-cutting-pleating/${row.productId}`
                        );
                    },
                },
            ];
        },
    },
    methods: {
        fetchProducts() {
            this.isLoadingProducts = true;

            cuttingPleatingApi
                .fetchProductsToValidate(this.filters)
                .then((response) => {
                    if (!response.data || !response.data.data) {
                        throw new Error();
                    }

                    this.products = response.data.data;
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans(
                            'cutting_pleating_validation.errors.fetch_products_to_validate'
                        )
                    );
                })
                .finally(() => {
                    this.isLoadingProducts = false;
                });
        },
        fetchDeliveryMethodOptions() {
            this.isLoadingDeliveryMethodOptions = true;

            cuttingPleatingApi
                .fetchDeliveryMethodOptions()
                .then((response) => {
                    if (!response.data || !response.data.data) {
                        throw new Error();
                    }

                    this.deliveryMethodOptions = response.data.data;
                })
                .catch((error) => {
                    this.deliveryMethodOptions = [];
                })
                .finally(() => {
                    this.deliveryMethodOptions.unshift({
                        label: this.trans(
                            'cutting_pleating_validation.filters.options.all_delivery_methods'
                        ),
                        value: null,
                    });
                    this.isLoadingDeliveryMethodOptions = false;
                });
        },
        fetchProductTypeOptions() {
            this.isLoadingProductTypeOptions = true;

            cuttingPleatingApi
                .fetchProductTypeOptions()
                .then((response) => {
                    if (!response.data || !response.data.data) {
                        throw new Error();
                    }

                    this.productTypeOptions = response.data.data;
                })
                .catch((error) => {
                    this.productTypeOptions = [];
                })
                .finally(() => {
                    this.productTypeOptions.unshift({
                        label: this.trans(
                            'cutting_pleating_validation.filters.options.all_product_types'
                        ),
                        value: null,
                    });
                    this.isLoadingProductTypeOptions = false;
                });
        },
        clearFilters() {
            this.filters = {
                productOrderId: null,
                deliveryMethodId: null,
                orderDate: null,
                colorId: null,
                productTypeId: null,
            };
        },
    },
    mounted() {
        this.fetchProducts();
        this.fetchDeliveryMethodOptions();
        this.fetchProductTypeOptions();
    },
    mixins: [localization],
    components: {
        Table,
    },
};
</script>
